import { atom, useRecoilState, useResetRecoilState } from 'recoil'

import { localStorageEffect } from '@/capacitor/recoil/localstorage-effect'

const pendingLinkAtom = atom<string | null>({
  key: '@app/pendingLink',
  default: null,
  effects: [localStorageEffect('@app/pendingLink')],
})

export function usePendingLink() {
  const [pendingLink, setPendingLink] = useRecoilState(pendingLinkAtom)
  const resetPendingLink = useResetRecoilState(pendingLinkAtom)

  return {
    pendingLink,
    setPendingLink,
    resetPendingLink,
  }
}
